<b-modal v-model="modal_requirement_148" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ヘッダー -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- 文言表示 -->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 文言表定義メッセージ -->
        <template v-if="phase !== 'indexDisplay'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <label class="box-margin-right work-support-message">
                  {{ workSupportMessage }}
                </label>
              </div>
            </div>
          </div>
        </template>
        <!-- Index表示画面 -->
        <template v-if="phase === 'indexDisplay'">
          <!-- 日時検索 -->
          <div class="date-search d-flex justify-content-end align-items-center mb-3">
            <span class="search-title">{{ $t(`${i18nWsKey}.label_date_and_time_search`) }}</span>
            <DateRangePicker class="col-4" v-model="selectedDate" :singleDatePicker=true :showDropdowns=true
              :localeData="{ firstDay: 1, format: 'yyyy/mm/dd', daysOfWeek: getDaysOnLocale }" :ranges=false
              :autoApply=true opens="right" :dateRange="selectedDate">
            </DateRangePicker>
            <div class="text-center">
              <svg-button variant="primary" normal size="sm" iconKey="search" title="common_button_search"
                @onclick="scrollItem()" />
            </div>
          </div>
          <div>
            <div class="simple-table">
              <table class="table table-sm">
                <thead>
                  <tr v-if="columns">
                    <th v-for="(column, i) in columns" :key="i">
                      <span>{{ $t(column.label) }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in showItems" :key="index" ref="targetRow">
                    <td v-for="(value, key) in item" :key="key" :class="getTdStyle(index)" class="cursor-default">
                      <input v-if="key === 'isChecked'" type="checkbox" @click="checkboxChanged(item)"
                        v-model="item[key]" :disabled="isSelectionLimit && !item[key]" :class="getCursorStyle(item)" />
                      <span v-else>{{ value }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
        <!-- ログデータあり表示 -->
        <template v-if="phase === 'dataResultsDisplay'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <div class="work-support-message">
                  <div v-if="resultItems.length > 0" v-for="(data, index) in resultItems" :key="index">
                    {{ $t(`${i18nWsKey}.label_log_number`, [data.number]) }}
                    <label v-if="data.upload_status === 'completed'">
                      {{ $t('message.common_title_success') }}
                    </label>
                    <label v-else>
                      {{ $t('individual.status_customize_result_failure')}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-overlay>
  </template>
  <!-- フッター -->
  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- Index表示 -->
      <template v-if="phase === 'indexDisplay'">
        <b-button size="sm" variant="outline-primary" @click="onCancelClicked" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="onOkClicked" :disabled="isDisabledAcquisition || isLoading"
          class="mx-2">
          {{ $t(`${i18nWsKey}.button_acquisition`) }}
        </b-button>
      </template>
      <!-- ログ取得 -->
      <template v-if="phase === 'dataAcquisition'">
        <!-- 通信中もキャンセルボタン押下可能 -->
        <b-button size="sm" variant="outline-primary" @click="onCancelClicked" class="mx-2" :disabled="isCanceled">
          {{ $t('message.common_button_cancel') }}
        </b-button>
      </template>
      <!-- ログデータあり画面、ログデータなし表示画面、エラー -->
      <template
        v-if="phase === 'dataResultsDisplay' || phase === 'dataNonExistence' || phase === 'acquisitionFailed' || phase === 'commonError'">
        <b-button size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="isLoading">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>